// removed by extract-text-webpack-plugin
module.exports = {"uploader":"uploader","dropzone-container":"dropzone-container","dropzone":"dropzone","invalid":"invalid","template":"template","failures":"failures","show":"show","tickers":"tickers"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AdvisorMode/HoldingsEditor/Uploader/Uploader.css
// module id = 1039
// module chunks = 0